<template>
  <section :class="{ 'about-section mb-10': true }">
    <GeneralTheme :theme="configuration">
      <h3
        v-if="label"
        :class="{
          'pb-15px text-13px font-extrabold uppercase leading-none tracking-[2.08px] text-www-color-accent lg:pb-18px': true,
          'before:relative before:-top-1 before:left-0 before:mr-10px before:inline-block before:h-2px before:w-25px before:bg-www-color-accent before:content-[\'\']': true,
        }"
      >
        {{ label }}
      </h3>

      <PortableText
        v-if="text?.videoPortableText"
        :portable-data="text.videoPortableText"
      />
    </GeneralTheme>
  </section>
</template>

<script lang="ts" setup>
import type { GeneralText } from '~/sanity/types';
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
defineProps<GeneralText>();
</script>

<style lang="scss">
.about-section {
  .container {
    margin: 0 !important;

    p.content {
      font-weight: 500;
    }
  }
  .image-atom {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>
